import React, {useState, useEffect, useCallback} from 'react';
import {Outlet} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Gatekeeper} from 'gatekeeper-client-sdk';
import {loadUser, logoutUser} from '@store/reducers/auth';
import {toggleSidebarMenu} from '@app/store/reducers/ui';
import {addWindowClass, removeWindowClass, sleep} from '@app/utils/helpers';
import ControlSidebar from '@app/modules/main/control-sidebar/ControlSidebar';
import Header from '@app/modules/main/header/Header';
import MenuSidebar from '@app/modules/main/menu-sidebar/MenuSidebar';
import Footer from '@app/modules/main/footer/Footer';
import {PfImage} from '@profabric/react-components';
import * as AuthService from '../../services/auth';
import styles from '../../pages/car/CSS/SurveyModal.module.css';

const Main = () => {
  const dispatch = useDispatch();
  const menuSidebarCollapsed = useSelector(
    (state: any) => state.ui.menuSidebarCollapsed
  );
  const controlSidebarCollapsed = useSelector(
    (state: any) => state.ui.controlSidebarCollapsed
  );
  const screenSize = useSelector((state: any) => state.ui.screenSize);
  const [isAppLoaded, setIsAppLoaded] = useState(false);
  const [mymenu, setMymenu] = useState([{
    name: 'เมนูการเดินทาง',
    icon: 'fa-car',
    children: [
      {
        name: 'การวางแผน',
        path: '/trip-make',
        enable: true
      },
      {
        name: 'การอนุมัติ',
        path: '/trip-approve',
        enable: true
      },
      {
        name: 'การเดินทาง | รถของฉัน',
        path: '/trip-me',
        enable: true
      },
      {
        name: 'ค่าใช้จ่ายกลุ่มต้นทุน',
        path: '/trip-costcenter',
        enable: true
      },
      {
        name: 'เบอร์คนขับรถ',
        path: '/trip-driver',
        enable: true
      },
      {
        name: 'รายงาน',
        path: '/trip-report',
        enable: true
      },
      {
        name: 'ปฏิทินรถยืม',
        path: '/trip-calendar',
        enable: true
      },
      {
        name: 'เมนู CR',
        path: '/trip-cr',
        enable: true
      }
    ]
  }]);

  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };

  const fetchProfile = async () => {
    try {
      const response = await Gatekeeper.getProfile();
      console.log(response)
      if (response.error === "invalid token") throw new Error(response.error);
      dispatch(loadUser(response));
      await sleep(1000);
      setIsAppLoaded(true);
    } catch (error) {
      console.log("error");
      console.log("error", error);
      // dispatch(logoutUser());
      // await sleep(1000);
      // setIsAppLoaded(true);
    }
  };

  const downloadMyMenu = async () => {
    try {
      const response = await AuthService.getMyMenu();
      if (response.error) throw response.error;
      setMymenu(response);
    } catch (error) {
      setMymenu([{
        name: 'เมนูการเดินทาง',
        icon: 'fa-car',
        children: [
          {
            name: 'การวางแผน',
            path: '/trip-make',
            enable: true
          },
          {
            name: 'การอนุมัติ',
            path: '/trip-approve',
            enable: true
          },
          {
            name: 'การเดินทาง | รถของฉัน',
            path: '/trip-me',
            enable: true
          },
          {
            name: 'ค่าใช้จ่ายกลุ่มต้นทุน',
            path: '/trip-costcenter',
            enable: true
          },
          {
            name: 'เบอร์คนขับรถ',
            path: '/trip-driver',
            enable: true
          },
          {
            name: 'รายงาน',
            path: '/trip-report',
            enable: true
          },
          {
            name: 'ปฏิทินรถยืม',
            path: '/trip-calendar',
            enable: true
          },
          {
            name: 'เมนู CR',
            path: '/trip-cr',
            enable: true
          }
        ]
      }]);
    }
  };

  useEffect(() => {
    removeWindowClass('register-page');
    removeWindowClass('login-page');
    removeWindowClass('hold-transition');

    addWindowClass('sidebar-mini');

    fetchProfile();

    downloadMyMenu();
    return () => {
      removeWindowClass('sidebar-mini');
    };
  }, []);

  useEffect(() => {
    removeWindowClass('sidebar-closed');
    removeWindowClass('sidebar-collapse');
    removeWindowClass('sidebar-open');
    if (menuSidebarCollapsed && screenSize === 'lg') {
      addWindowClass('sidebar-collapse');
    } else if (menuSidebarCollapsed && screenSize === 'xs') {
      addWindowClass('sidebar-open');
    } else if (!menuSidebarCollapsed && screenSize !== 'lg') {
      addWindowClass('sidebar-closed');
      addWindowClass('sidebar-collapse');
    }
  }, [screenSize, menuSidebarCollapsed]);

  useEffect(() => {
    if (controlSidebarCollapsed) {
      removeWindowClass('control-sidebar-slide-open');
    } else {
      addWindowClass('control-sidebar-slide-open');
    }
  }, [screenSize, controlSidebarCollapsed]);

  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return (
        <div className="preloader flex-column justify-content-center align-items-center">
          <PfImage
            className="animation__shake"
            src="/img/logo.png"
            alt="AdminLTELogo"
            height={60}
            width={60}
          />
        </div>
      );
    }
    return (
      <>
      {/* <div className={styles['marquee-container']}>
        <div className={styles['marquee-text']}>
          📢 อัพเดตหลักเกณฑ์การเบิกค่าใช้จ่ายการเดินทางกรณีปฏิบัติงานนอกสถานที่ อ่านเพิ่มเติม 
          <a 
            href="https://itservice.advanceagro.net/Service/traveling/manual/%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8C%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9A%E0%B8%B4%E0%B8%81%E0%B8%84%E0%B9%88%E0%B8%B2%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%88%E0%B9%88%E0%B8%B2%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%94%E0%B8%B4%E0%B8%99%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%B5%E0%B8%9B%E0%B8%8F%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%99%E0%B8%AD%E0%B8%81%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%20CDS%2003.2569%201.pdf" 
            target="_blank" 
            rel="noreferrer"
            style={{ marginLeft: '5px', color: '#0056b3', textDecoration: 'underline' }}
          >
            คลิ๊ก!
          </a>
        </div>
      </div> */}
        <Header />

        <MenuSidebar mymenu={mymenu}/>

        <div className="content-wrapper">
          <div className="pt-3" />
          <section className="content">
            <Outlet />
          </section>
        </div>
        <Footer />
        <ControlSidebar />
        <div
          id="sidebar-overlay"
          role="presentation"
          onClick={handleToggleMenuSidebar}
          onKeyDown={() => {}}
        />
      </>
    );
  }, [isAppLoaded]);

  return <div className="wrapper">{getAppTemplate()}</div>;
};

export default Main;
